export default "__VITE_ASSET__C8tF8i9C__"